import { ProposedToTheSubCommittee4FormComponent } from "../../../components/borrowSystem/ProposedToTheSubCommittee/ProposedToTheSubCommittee4FormComponent";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";

export function PoposedToTheSubCommittee4FormContainer () {
    const titleName =`แบบเสนอคณะอนุกรรมการพิจารณาให้กู้ยืมกองทุนพัฒนาฝีมือแรงงาน`; //ใส่ชื่อtitle ตรงนี้
    const subtitle= "(สำหรับผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงานและผู้ประกอบกิจการ)"
    return(
        <div className="page-container bg-landing">
            <NavbarBorrowSystem/>
            <HeadTitle title={titleName} subtitle={subtitle} />
            <ProposedToTheSubCommittee4FormComponent/>
            <Footer />
        </div>

    )
}




